"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoThumbnail = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./VideoThumbnail.css"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var classnames_1 = __importDefault(require("classnames"));
var DraggableThumbnail_1 = require("../SharedComponents/DraggableThumbnail");
var VideoThumbnail = function (_a) {
    var asset = _a.asset, onClick = _a.onClick, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd;
    return (react_1.default.createElement(DraggableThumbnail_1.DraggableThumbnail, { onDragStart: onDragStart, onDragEnd: onDragEnd, onClick: onClick, thumbnailImage: asset.content.lowResThumbnail, label: asset.name },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.thumbnailMetadataContainer, justify: "end" },
            react_1.default.createElement(kaleidoscope_1.Stack, { relative: true, direction: "horizontal", align: "end", className: (0, classnames_1.default)(tokens_1.darkTheme, styles.thumbnailMetadata), padding: "xxs", paddingTop: "l", gap: "xxs" },
                react_1.default.createElement(icons_1.Play, { size: icons_1.IconSize.Small, color: "default", "aria-hidden": true, className: styles.iconSpacing }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", theme: "dark" }, asset.content.duration)))));
};
exports.VideoThumbnail = VideoThumbnail;
